module.exports = __webpack_public_path__ + "static/team-c52f137ac8a1555474a8637f50a219bb.png";